// extracted by mini-css-extract-plugin
module.exports = {"sortSimple":"TopList_sortSimple__2n0DU"};